import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

export const COOKIE_CONSENT_KEY = 'gaia_cookie_consent'

export type CookieConsent = 'accepted' | 'declined' | null

const CookieBanner = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY)
    if (!stored) setVisible(true)
  }, [])

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted')
    setVisible(false)
    window.dispatchEvent(new Event('cookieConsentUpdated'))
  }

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      aria-live="polite"
      className="fixed bottom-0 left-0 right-0 z-50 bg-dark-background border-t border-gray-700 shadow-2xl"
    >
      <div className="container-custom py-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1 min-w-0">
            <p className="text-white font-semibold mb-1">We use cookies</p>
            <p className="text-gray-300 text-sm leading-relaxed">
              We use analytics cookies to understand how visitors use our site so we can improve it.
              Essential cookies are always active.{' '}
              <Link to="/cookies" className="text-primary-green hover:underline focus:outline-none focus:ring-1 focus:ring-primary-green rounded">
                Cookie policy
              </Link>
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-sm text-gray-300 border border-gray-600 rounded-lg hover:border-gray-400 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="px-5 py-2 text-sm bg-primary-green text-white rounded-lg hover:bg-secondary-green transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-primary-green focus:ring-offset-2 focus:ring-offset-dark-background"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookieBanner
